// Self-Contained Video Modal Script (YouTube + MP4)
// No HTML modification required - creates modal dynamically
(function() {
  'use strict';
  
  // Configuration - easily customisable
  const config = {
    // Add your button selectors here (the app buttons you want to intercept)
    buttonSelectors: [
      'a[href*="youtube.com"]',           // Any link containing youtube.com
      'a[href*="youtu.be"]',             // Any link containing youtu.be
      'a[href*="youtube.com/shorts"]',   // YouTube Shorts links
      'a[href$=".mp4"]',                 // Any link ending with .mp4
      'a[href*=".mp4?"]',                // MP4 with query parameters
      'a[href*=".mp4#"]',                // MP4 with hash
      '.dsgn-pck__button[href$=".mp4"]', // Your specific button class with MP4
      '.dsgn-pck__button[href*=".mp4"]', // Your button class with MP4 (any position)
      '[data-video-trigger]',            // Custom data attribute for any video
      '[data-youtube-trigger]',          // Custom data attribute for YouTube
      '.video-trigger',                  // Custom class for any video
      '.youtube-trigger',                // Custom class for YouTube
      // Add more selectors as needed for your specific app buttons
    ],
    
    // Default video settings
    autoplay: true,
    modestbranding: true,
    rel: false
  };
  
  let modal, iframe, videoElement, closeBtn;
  
  // Create modal HTML structure dynamically
  function createModalHTML() {
    const modalHTML = `
      <div id="videoModal" class="video-modal">
        <div class="video-modal-content">
          <div class="video-modal-header">
            <h2 class="video-modal-title">Watch Video</h2>
            <button id="closeVideoModal" class="video-modal-close">&times;</button>
          </div>
          <div class="video-container">
            <iframe id="videoIframe" 
                    src="" 
                    frameborder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowfullscreen
                    style="display: none;">
            </iframe>
            
            <video id="videoElement" 
                   controls 
                   preload="metadata"
                   style="display: none;"
                   width="100%" 
                   height="100%">
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    `;
    
    // Insert modal at end of body
    document.body.insertAdjacentHTML('beforeend', modalHTML);
  }
  
  // Inject CSS styles dynamically
  function injectCSS() {
    const css = `
      /* Enhanced Video Modal Styles (YouTube + MP4) */
      .video-modal {
        display: none;
        position: fixed;
        z-index: 9999;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        backdrop-filter: blur(5px);
      }

      .video-modal-content {
        position: relative;
        margin: 5% auto;
        width: 90%;
        max-width: 800px;
        background-color: #000;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
      }

      .video-modal-header {
        position: relative;
        padding: 10px 15px;
        background: rgba(0, 0, 0, 0.9);
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }

      .video-modal-title {
        display: none;
      }

      .video-modal-close {
        color: white;
        font-size: 28px;
        font-weight: bold;
        cursor: pointer;
        background: none;
        border: none;
        padding: 0;
        width: 35px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: background-color 0.3s ease;
      }

      .video-modal-close:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }

      .video-container {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 56.25%; /* 16:9 aspect ratio for regular videos */
      }

      .video-container iframe,
      .video-container video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: none;
        background: #000;
      }

      /* Video element specific styling */
      .video-container video {
        object-fit: contain; /* Maintain aspect ratio for MP4 videos */
      }

      /* YouTube Shorts styling - vertical aspect ratio */
      .video-short {
        max-width: 400px;
        width: 90%;
      }

      .video-short-container {
        padding-bottom: 177.78%; /* 9:16 aspect ratio for shorts */
      }

      /* Mobile responsive */
      @media (max-width: 768px) {
        .video-modal-content {
          margin: 10% auto;
          width: 95%;
        }
        
        .video-modal-header {
          padding: 8px 12px;
        }
        
        .video-modal-close {
          width: 30px;
          height: 30px;
          font-size: 24px;
        }
        
        /* YouTube Shorts on mobile */
        .video-short {
          max-width: 350px;
          width: 85%;
        }
      }

      /* Animation for smooth opening/closing */
      .video-modal.show {
        display: block;
        animation: fadeIn 0.3s ease-out;
      }

      .video-modal.hide {
        animation: fadeOut 0.3s ease-out;
      }

      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }

      @keyframes fadeOut {
        from { opacity: 1; }
        to { opacity: 0; }
      }
    `;
    
    // Check if styles already exist
    if (document.getElementById('videoModalStyles')) return;
    
    const style = document.createElement('style');
    style.id = 'videoModalStyles';
    style.textContent = css;
    document.head.appendChild(style);
  }
  
  // Initialise modal elements
  function initModal() {
    // Inject CSS first
    injectCSS();
    
    // Create modal HTML if it doesn't exist
    if (!document.getElementById('videoModal')) {
      createModalHTML();
    }
    
    modal = document.getElementById('videoModal');
    iframe = document.getElementById('videoIframe');
    videoElement = document.getElementById('videoElement');
    closeBtn = document.getElementById('closeVideoModal');
    
    if (!modal || !iframe || !videoElement || !closeBtn) {
      console.warn('Video modal elements not found');
      return false;
    }
    
    // Close modal event listeners
    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function(e) {
      if (e.target === modal) closeModal();
    });
    
    // ESC key to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('show')) {
        closeModal();
      }
    });
    
    return true;
  }
  
  // Extract YouTube video ID from various URL formats including Shorts
  function getYouTubeVideoId(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  }
  
  // Check if URL is a YouTube video
  function isYouTubeUrl(url) {
    return url.includes('youtube.com') || url.includes('youtu.be');
  }
  
  // Check if URL is a YouTube Short
  function isYouTubeShort(url) {
    return url.includes('/shorts/');
  }
  
  // Check if URL is an MP4 video
  function isMp4Video(url) {
    return url.toLowerCase().includes('.mp4');
  }
  
  // Build YouTube embed URL with parameters
  function buildYouTubeEmbedUrl(videoId) {
    const params = new URLSearchParams({
      autoplay: config.autoplay ? '1' : '0',
      modestbranding: config.modestbranding ? '1' : '0',
      rel: config.rel ? '1' : '0',
    });
    
    return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
  }
  
  // Open modal with video
  function openModal(videoUrl, title = 'Watch Video') {
    console.log('Opening modal with URL:', videoUrl);
    
    // Reset both video containers
    iframe.src = '';
    videoElement.src = '';
    iframe.style.display = 'none';
    videoElement.style.display = 'none';
    
    const modalContent = modal.querySelector('.video-modal-content');
    const videoContainer = modal.querySelector('.video-container');
    
    if (isYouTubeUrl(videoUrl)) {
      // Handle YouTube videos
      const videoId = getYouTubeVideoId(videoUrl);
      
      if (!videoId) {
        console.warn('Invalid YouTube URL:', videoUrl);
        return;
      }
      
      const embedUrl = buildYouTubeEmbedUrl(videoId);
      iframe.src = embedUrl;
      iframe.style.display = 'block';
      
      // Check if it's a YouTube Short and adjust modal styling
      const isShort = isYouTubeShort(videoUrl);
      
      if (isShort) {
        modalContent.classList.add('video-short');
        videoContainer.classList.add('video-short-container');
      } else {
        modalContent.classList.remove('video-short');
        videoContainer.classList.remove('video-short-container');
      }
      
    } else if (isMp4Video(videoUrl)) {
      // Handle MP4 videos
      videoElement.src = videoUrl;
      videoElement.style.display = 'block';
      
      // MP4 videos use standard 16:9 ratio
      modalContent.classList.remove('video-short');
      videoContainer.classList.remove('video-short-container');
      
      // Auto-play MP4 if configured
      if (config.autoplay) {
        videoElement.play().catch(e => {
          console.log('Auto-play prevented:', e);
        });
      }
    } else {
      console.warn('Unsupported video format:', videoUrl);
      return;
    }
    
    // Update title if provided
    const titleElement = modal.querySelector('.video-modal-title');
    if (titleElement && title) {
      titleElement.textContent = title;
    }
    
    modal.classList.add('show');
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  }
  
  // Close modal
  function closeModal() {
    modal.classList.remove('show');
    modal.classList.add('hide');
    
    // Stop all videos
    iframe.src = '';
    videoElement.pause();
    videoElement.src = '';
    
    setTimeout(() => {
      modal.classList.remove('hide');
      document.body.style.overflow = ''; // Restore scrolling
    }, 300);
  }
  
  // Intercept clicks on video links
  function interceptVideoLinks() {
    config.buttonSelectors.forEach(selector => {
      document.addEventListener('click', function(e) {
        const element = e.target.closest(selector);
        if (!element) return;
        
        let videoUrl;
        let title = 'Watch Video';
        
        // Get URL from href attribute
        if (element.href) {
          videoUrl = element.href;
        }
        // Get URL from data attribute
        else if (element.dataset.videoUrl) {
          videoUrl = element.dataset.videoUrl;
        }
        // Get URL from data-video-trigger attribute
        else if (element.dataset.videoTrigger) {
          videoUrl = element.dataset.videoTrigger;
        }
        // Get URL from data-youtube-trigger attribute
        else if (element.dataset.youtubeTrigger) {
          videoUrl = element.dataset.youtubeTrigger;
        }
        
        // Get custom title if provided
        if (element.dataset.videoTitle) {
          title = element.dataset.videoTitle;
        } else if (element.title) {
          title = element.title;
        } else if (element.textContent.trim()) {
          title = element.textContent.trim();
        }
        
        // Check if it's a supported video format
        if (videoUrl && (isYouTubeUrl(videoUrl) || isMp4Video(videoUrl))) {
          e.preventDefault();
          e.stopPropagation();
          openModal(videoUrl, title);
        }
      }, true); // Use capture phase to intercept before other handlers
    });
  }
  
  // Enhanced mutation observer to handle dynamically loaded content
  function observeForNewButtons() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Re-scan for new video buttons after DOM changes
          // This handles apps that load content dynamically
          setTimeout(interceptVideoLinks, 100);
        }
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Global function to manually trigger modal (for custom integration)
  window.openVideoModal = function(videoUrl, title) {
    if (modal) {
      openModal(videoUrl, title);
    }
  };
  
  // Backward compatibility
  window.openYouTubeModal = window.openVideoModal;
  
  // Initialise everything when DOM is ready
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    
    if (!initModal()) {
      // Retry after a short delay if elements aren't ready
      setTimeout(init, 500);
      return;
    }
    
    interceptVideoLinks();
    observeForNewButtons();
    
    console.log('Enhanced Video Modal initialised successfully');
  }
  
  init();
})();